import React, { useEffect, useState } from 'react';
import axios from '../../services/axiosInstance';
import AdminYmdEvent from "../../components/web/layoutsadmin/AdminYmdEvent";
import maCateImg from "../../assets/img/m-a-cate.png";
import ApexCharts from 'react-apexcharts';
import { TbRefresh } from 'react-icons/tb';

export default function AdminSalesStatusPg() {

    /** region function */

    const [salesData, setSalesData] = useState({});
    const [barChartData, setBarChartData] = useState({ purchaseData: [], deliveryData: [] });
    const [monthlyChartData, setMonthlyChartData] = useState([]);

    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');

    useEffect(() => {
        axios.get('/outsales/monthly-summary')
            .then(res => {
                const chartData = res.data.map(item => ({
                    sDate: `${parseInt(item.yearMonth.slice(4), 10)}월`,
                    prod:  item.prod,
                    del:   item.del
                }));
                setMonthlyChartData(chartData);
            })
            .catch(err => {
                console.error('월별 매출 집계 조회 실패:', err);
            });
        }, []);

    useEffect(() => {
        const today = new Date();
        const fmt = d => {
            const y = d.getFullYear();
            const m = String(d.getMonth() + 1).padStart(2, '0');
            const day = String(d.getDate()).padStart(2, '0');
            return `${y}-${m}-${day}`;
        };
        const f = fmt(today);
        setStartDate(f);
        setEndDate(f);
    }, []);

    useEffect(() => {
        if (!startDate || !endDate) return;
        const fetchData = async () => {
            try {
                const res = await axios.get('/outsales/selectOutsales', {
                    params: {
                        startDate: startDate.replace(/-/g, ''),
                        endDate: endDate.replace(/-/g, ''),
                    }
                });
                console.log("반환데이터 : ", res.data)
                setSalesData(res.data);
            } catch (err) {
                console.error('데이터 조회 실패:', err);
            }
        };
        fetchData();
    }, [startDate, endDate]);

    useEffect(() => {
        if (!salesData || Object.keys(salesData).length === 0) return;
        const purchaseData = [
            salesData.cartPrice || 0,
            salesData.ordPrice || 0,
            salesData.offPrice || 0,
            salesData.trPrice || 0,
            salesData.domPrice || 0,
            salesData.ttEtcPrice || 0,
            salesData.ttEtcFee || 0,
            salesData.ttCardFee|| 0,
        ];
        const deliveryData = [
            salesData.ttFedexPrice || 0,
            salesData.ttFedexEcoPrice || 0,
            salesData.ttUpsPrice || 0,
            salesData.ttUpsEcoPrice || 0,
            salesData.ttEmsPrice || 0,
            salesData.ttEmsPrePrice || 0,
            salesData.ttKPackPrice || 0,
            salesData.ttAirSPrice || 0,
            salesData.ttSeaPrice || 0,
            salesData.ttDomPrice || 0,
            salesData.useDeposit || 0,
            salesData.usePoint || 0,
            salesData.useCoupon || 0,
            salesData.appSale || 0,
        ];
        setBarChartData({ purchaseData, deliveryData });
    }, [salesData]);

    // Line 차트
    const lineSeries = [
        { name: '구매비', data: monthlyChartData.map(x => x.prod) },
        { name: '배송비', data: monthlyChartData.map(x => x.del) },
    ];

    const categories = [
        'Fedex','Fedex-E','UPS','UPS-E','EMS','EMSP',
        'K-Packet','Small-Packet','Sea','국내택배',
        '예적쿠&앱할인'
    ];

    const lineOptions = {
        chart: { type: 'line',
                toolbar: {
                    show: true,
                    tools: {
                        download: true,
                        zoom: false,
                        zoomin: false,
                        zoomout: false,
                        pan: false,
                        reset: false,
                    }
                },
            },
        theme: {
            fontFamily: 'NanumSquareNeo, sans-serif'
        },
        stroke: { curve: 'smooth', width: [3, 3], dashArray: [0, 6] },
        xaxis: {
            categories: monthlyChartData.map(x => x.sDate),
            labels: {
                style: {
                    fontFamily: 'NanumSquareNeo, sans-serif'
                }
            },
        },
        yaxis: { labels: { formatter: v => `₩${v.toLocaleString()}` } },
        tooltip: {
            x: {
                show: false
            },
            y: {
                formatter: v => `₩${v.toLocaleString()}`,
                title: {
                    formatter: seriesName => seriesName === '구매비' ? '구매금액' : '배송금액'
                },
                style: {
                    fontFamily: 'NanumSquareNeo, sans-serif'
                }
            }
        },
        dataLabels: {
            enabled: false,
            style: {
                fontFamily: 'NanumSquareNeo, sans-serif'
            }
        },
        title: {
            text: '지난 1년 월별 매출 추이',
            align: 'left',
            style: {
                fontFamily: 'NanumSquareNeo, sans-serif',
                fontWeight: 'bold'
            }
        },
        colors: ['#FF9924', '#ffce52'],
        markers: {
            size: 4,
            colors: ['#FF9924', '#ffce52'],
            strokeWidth: 2,
            strokeColors: ['#fff', '#fff'],
            hover: { sizeOffset: 2 }
        },
    };

    // X Bar 차트
    const prodState = {
        series: [{ name: '구매비용 & 수수료', data: barChartData.purchaseData }],
        options: {
            chart: { type: 'bar', toolbar: {
                    show: true,
                    tools: {
                        download: true,
                        zoom: false,
                        zoomin: false,
                        zoomout: false,
                        pan: false,
                        reset: false,
                    }
                } },
            theme: {
                fontFamily: 'NanumSquareNeo, sans-serif'
            },
            colors: ['#FF9924'],
            plotOptions: { bar: { borderRadius: 4, borderRadiusApplication: 'end', horizontal: true, barHeight: '70%' } },
            dataLabels: { enabled: true, style: { colors: ['#fff'], fontSize: '12px' }, formatter: v => `₩ ${v.toLocaleString()}` },
            xaxis: { categories: ['장바구니','구매대행','오프라인','이체대행','국내배송','총기타비용','총수수료','총카드수수료'],
                title: { text: '' },
                labels: {
                    show: true,
                    formatter: v => `₩ ${v.toLocaleString()}`,
                    style: { fontFamily: 'NanumSquareNeo, sans-serif' }
                },
                axisTicks: { show: false },
                axisBorder: { show: false }
            },
            tooltip: { y: { formatter: v => `₩ ${v.toLocaleString()}` } },
            title: { text: '구매비용 & 수수료', align: 'left',style: {
                    fontFamily: 'NanumSquareNeo, sans-serif',
                    fontWeight: 'bold'
                } },
        }
    };

    const raw = barChartData.deliveryData;

    const baseSeries = categories.slice(0, 10).map((label, i) => ({
        name: label,
        data: categories.map((_, j) => j === i ? (raw[i] || 0) : 0)
    }));

    const discountKeys = [
        { name: '예치금사용', idx: 10 },
        { name: '적립금사용', idx: 11 },
        { name: '쿠폰사용',   idx: 12 },
        { name: '앱할인',     idx: 13 },
    ];
    const discountSeries = discountKeys.map(({ name, idx }) => ({
        name,
        data: categories.map((_, j) => j === 10 ? (raw[idx] || 0) : 0)
    }));

    const delState = {
        series: [...baseSeries, ...discountSeries],
        options: {
            chart: {
                type: 'bar',
                stacked: true,
                toolbar: {
                    show: true,
                    tools: {
                        download: true,
                        zoom:    false,
                        zoomin:  false,
                        zoomout: false,
                        pan:     false,
                        reset:   false,
                    }
                }
            },
            theme: {
                fontFamily: 'NanumSquareNeo, sans-serif'
            },
            plotOptions: {
                bar: {
                    horizontal: true,
                    borderRadius: 4,
                    barHeight: '75%',
                    borderRadiusApplication: 'end'
                }
            },
            colors: [
                '#ffce52','#ffce52','#ffce52','#ffce52','#ffce52',
                '#ffce52','#ffce52','#ffce52','#ffce52','#ffce52',
                '#ffce52','#ff401f','#9f9f9f','#00b463'
            ],
            dataLabels: {
                enabled: true,
                style: { colors: ['#fff'], fontSize: '12px' },
                formatter: v => `₩${v.toLocaleString()}`
            },
            xaxis: {
                categories: [
                    'Fedex','Fedex-E','UPS','UPS-E','EMS','EMSP',
                    'K-Packet','Small-Packet','Sea','국내택배','예적쿠&앱할인'
                ],
                // numeric(금액) 축
                title: { text: '' },
                labels: {
                    show: true,
                    formatter: v => `₩${v.toLocaleString()}`,
                    style: { fontFamily: 'NanumSquareNeo, sans-serif' }
                },
                axisTicks:  { show: false },
                axisBorder: { show: false }
            },

            tooltip: {
                x: { show: false },
                y: { formatter: v => `₩${v.toLocaleString()}` }
            },
            title: { text: '배송비 & 예적쿠사용', align: 'left',
                style: { fontFamily: 'NanumSquareNeo, sans-serif' } },
            legend: { show: false }
        }
    };

    const handleRange = months => {
        const today = new Date();
        const past = new Date(); past.setMonth(today.getMonth() - months);
        const fmt = d => `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}`;
        setStartDate(fmt(past));
        setEndDate(fmt(today));
    };

    /** endregion function **/

    return (
        <div className="AdminSalesStatusPg font-t-cont">
            <div className="admin-work-title">
                <img className="wd-35 ht-35" src={maCateImg} alt="매출현황" />
                <p className="p-t-6">매출현황</p>
            </div>
            <div className="admin-wrap">
                <div className="admin-wrap-card m-b-40">
                    <div className="ht-400 wd-100pc">
                        <ApexCharts options={lineOptions} series={lineSeries} type="line" width="100%" height="100%" />
                    </div>
                </div>
                <div className="admin-wrap-card">
                    <div className="admin-event-wrap"><div className="admin-event-wrap-btn">
                        <AdminYmdEvent startDate={startDate} endDate={endDate} startHandle={e=>setStartDate(e.target.value)} endHandle={e=>setEndDate(e.target.value)} />
                        <button onClick={()=>handleRange(6)} className="admin-btn-B wd-60 ht-30 font-s-13 m-r-15">6개월</button>
                        <button onClick={()=>handleRange(12)} className="admin-btn-B wd-60 ht-30 font-s-13 m-r-15">1년</button>
                        <TbRefresh onClick={()=>handleRange(0)} className="c-point font-s-24 m-t-2" />
                    </div></div>
                    <div className="display-flex flex-row ht-400">
                        <div className="wd-40pc m-r-15">
                            <ApexCharts {...prodState} type="bar" width="100%" height="100%" />
                        </div>
                        <div className="wd-60pc">
                            <ApexCharts {...delState} type="bar" width="100%" height="100%" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
